var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",class:{ 'sidebar--collapsed': _vm.collapsed }},[_c('div',{staticClass:"sidebar__logo"}),_c('div',{staticClass:"sidebar__overlay"}),_c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.hideSidebarOutclicked),expression:"hideSidebarOutclicked"}],staticClass:"sidebar__menu"},[_c('SidebarMenu',{staticStyle:{"margin-bottom":"0px"},attrs:{"menu":[
        {
          icon: 'home',
          moduleURL: '',
          name: 'Dashboard',
          child: null,
        },
      ]}}),_c('SidebarMenu',{staticStyle:{"margin-top":"0px"},attrs:{"menu":_vm.menu}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }